/* Studio Next — Sticker Sheets.
   Several die-cut designs on one sheet: each sticker is kiss-cut (CutContour),
   the sheet edge is a through-cut (separate "SheetCut" spot colour).
   Lives inside the builder's own layout (same header, toolbar, panel, price box),
   switched on by "Single stickers | Sticker sheet" (or ?sheet=1). Each sticker is designed in the real builder (every tool works:
   borders, background removal, text, clipart, AI image, QR, templates, crop…) and
   placed on the sheet from the builder's own print raster + cut path. Prices must match SHEET_PRICING in the print-api Worker,
   which re-checks every order. */
/* overlays live in #smnLayer, not directly in <body>: the builder CSS resets padding/transform/max-width on
   every direct body child, which breaks centred pop-ups */
window.smnLayer = window.smnLayer || function () { var l = document.getElementById('smnLayer'); if (!l) { l = document.createElement('div'); l.id = 'smnLayer'; document.body.appendChild(l); } return l; };
(function () {
  'use strict';

  var WORKER = 'https://print-api.stickermint.workers.dev';
  var PUBLIC_KEY = 'sm_print_a7x9K2mP4qR8wL3nvx920123';
  var SHEETS = {
    '4x6': { w: 4, h: 6, label: '4″ × 6″' },
    '5.5x8.5': { w: 5.5, h: 8.5, label: '5.5″ × 8.5″' },
    '8.5x11': { w: 8.5, h: 11, label: '8.5″ × 11″' }
  };
  var PRICING = {
    sizes: { '4x6': 8, '5.5x8.5': 10, '8.5x11': 14 },
    holo_extra: 0.35,
    qty_multipliers: [[1, 1], [5, 0.8], [10, 0.6], [25, 0.45], [50, 0.38], [100, 0.32]]
  };
  var QTYS = [1, 5, 10, 25, 50, 100];
  var BORDER_MM = { small: 1.6, medium: 2.8, large: 4.4 };
  var MARGIN = 0.25;   // inches kept clear inside the sheet edge
  var GAP = 0.125;     // inches between two stickers' cut lines
  var BLEED = 0.125;   // page is the sheet + this on every side; SheetCut sits on the sheet edge
  var SRC_MAX = 1800;  // source images are capped to this many px on the long side

  function tierMult(n) {
    var t = PRICING.qty_multipliers, m = 1;
    for (var i = t.length - 1; i >= 0; i--) if (n >= t[i][0]) { m = t[i][1]; break; }
    return m;
  }
  function sheetTotal(size, finish, n) {
    var holo = /holo/i.test(finish) ? 1 + PRICING.holo_extra : 1;
    return Math.floor(PRICING.sizes[size] * holo * n * tierMult(n));
  }

  function start() {
    if (window._smshStarted) return;
    window._smshStarted = 1;
    var fabric = window.fabric;
    if (!fabric) return;
    var toast = function (m, k, act) { (window.SMNX && window.SMNX.toast) ? window.SMNX.toast(m, k, act) : console.log(m); };

    var S = { size: '5.5x8.5', finish: 'matte', border: 'small', sheets: 10, open: false };
    var SMN = window.SMN, B = SMN.state; // the builder
    var editing = null, singleSnap = null, singleShare = null; // sheet sticker being edited in the builder; the customer's own design
    var canvas = null, ppi = 40, hideGuides = false;


    /* ---------------- DOM: mounted inside the builder's own layout ----------------
       desktop: stage → .sms-canvas-area, options → .sms-config (same switch, sections,
       price box, ADD TO CART as single stickers). phone: options → the specs screen,
       stage → the editor, actions → a bottom toolbar built from the builder's buttons. */
    var html = document.documentElement;
    var isPhone = function () { return window.matchMedia('(max-width: 768px)').matches; };
    function h(markup) { var d = document.createElement('div'); d.innerHTML = markup.trim(); return d.firstChild; }
    function pills(name, list, cur, cls) {
      return list.map(function (it) {
        var on = String(it[0]) === String(cur);
        return '<button type="button" class="' + cls + (on ? ' on active' : '') + '" data-' + name + '="' + it[0] + '">' + it[1] + '</button>';
      }).join('');
    }
    var SIZE_LIST = Object.keys(SHEETS).map(function (k) { return [k, SHEETS[k].label]; });
    var FINISH_LIST = [['matte', 'Matte'], ['glossy', 'Glossy'], ['holographic', 'Holo']];
    var SHEETS_LIST = QTYS.map(function (q) { return [q, q]; });
    var FILE_IN = '<input type="file" accept="image/png,image/jpeg,image/webp,image/gif,image/svg+xml" multiple hidden>';
    var IC = {
      plus: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="3" width="18" height="18" rx="2"/><path d="M12 8v8M8 12h8"/></svg>',
      upload: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4"/><polyline points="17 8 12 3 7 8"/><line x1="12" y1="3" x2="12" y2="15"/></svg>',
      grid: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/></svg>',
      copy: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="9" y="9" width="12" height="12" rx="1"/><path d="M5 15H4a1 1 0 01-1-1V4a1 1 0 011-1h10a1 1 0 011 1v1"/></svg>',
      cart: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 002 1.61h9.72a2 2 0 002-1.61L23 6H6"/></svg>',
      down: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M6 9l6 6 6-6"/></svg>'
    };
    function sec(label, body) { return '<div class="sms-config-section smsh-sec"><h3>' + label + '</h3>' + body + '</div>'; }
    function grp(label, body) { return '<div class="sl2-spec-group smsh-grp"><label class="sl2-spec-label">' + label + '</label>' + body + '</div>'; }

    // centre: the sheet stage
    var canvasArea = document.querySelector('.sms-canvas-area') || document.body;
    var stage = h('<div class="smsh-stage" aria-label="Sticker sheet">' +
      '<div class="smsh-chip"><b>Sticker sheet</b><span class="smsh-count"></span></div>' +
      '<div class="smsh-tools"><button type="button" data-act="arrange">' + IC.grid + 'Auto-arrange</button>' +
      '<button type="button" data-act="fillall">' + IC.copy + 'Fill with copies</button></div>' +
      '<p class="smsh-warn" hidden></p>' +
      '<div class="smsh-paper"><canvas id="smshCanvas"></canvas></div>' +
      '<div class="smsh-empty"><b>Add your first sticker</b><span class="smsh-empty-d">Design it with every tool on the left, or drop in several images at once.</span>' +
      '<span class="smsh-empty-m">Design it with the full sticker tools, or upload several images at once.</span>' +
      '<div class="smsh-empty-act"><button type="button" class="smsh-pill on" data-act="new">Add sticker</button>' +
      '<label class="smsh-pill">Upload multiple' + FILE_IN + '</label></div></div>' +
      '<div class="smsh-sel" hidden>' +
      '<label class="smsh-size">Size <input type="range" min="0.75" max="4" step="0.05"><b></b></label>' +
      '<button type="button" data-act="edit" class="primary" title="Open this sticker in the designer">Edit design</button>' +
      '<button type="button" data-act="dup">Duplicate</button>' +
      '<button type="button" data-act="fill" title="Fill the free space with copies">Fill sheet</button>' +
      '<button type="button" data-act="rot">Rotate</button>' +
      '<button type="button" data-act="bg" hidden>Remove bg</button>' +
      '<button type="button" data-act="del" class="danger">Delete</button>' +
      '</div></div>');
    canvasArea.appendChild(stage);
    // the empty-state message lives on the sheet itself so it always fits inside it
    stage.querySelector('.smsh-paper').appendChild(stage.querySelector('.smsh-empty'));
    var paper = stage.querySelector('.smsh-paper'), selBar = stage.querySelector('.smsh-sel'), sizeIn = stage.querySelector('.smsh-size input');

    // right panel (desktop): same sections + price box as single stickers
    var cfg = document.querySelector('.sms-config');
    var panel = h('<div class="smsh-cfg">' +
      sec('Add', '<div class="smsh-row"><button type="button" class="smsh-pill on" data-act="new">Add sticker</button>' +
        '<label class="smsh-pill">Upload multiple' + FILE_IN + '</label></div>') +
      sec('Sheet', '<div class="smsh-row smsh-g3" data-group="size">' + pills('size', SIZE_LIST, S.size, 'smsh-pill') + '</div>') +
      sec('Finish', '<div class="smsh-row smsh-g3" data-group="finish">' + pills('finish', FINISH_LIST, S.finish, 'smsh-pill') + '</div>') +
      sec('Sheets', '<div class="smsh-row smsh-g7" data-group="sheets">' + pills('sheets', SHEETS_LIST, S.sheets, 'smsh-pill') +
        '<input class="smsh-qty" type="number" min="1" max="1000" inputmode="numeric" aria-label="Custom number of sheets" placeholder="Other"></div>') +
      '<div class="sms-price-box smsh-pricebox">' +
      '<div style="display:flex;align-items:baseline;gap:6px;margin-bottom:4px;flex-wrap:wrap;"><span class="sms-price-total smsh-total"></span><span class="sms-price-unit smsh-each"></span></div>' +
      '<button type="button" class="sms-atc-bottom smsh-atc" style="width:100%;">' + IC.cart.replace('<svg ', '<svg width="16" height="16" ') + ' ADD TO CART</button>' +
      '</div>' +
      '</div>');
    // while designing one sticker of the sheet: this card takes the price box's place
    var editCard = h('<div class="sms-price-box smsh-editcard">' +
      '<div class="smsh-editcard-t"><b>Sticker for your sheet</b><span>Finish, number of sheets and price are set on the sheet. Size here is the sticker’s real size.</span></div>' +
      '<button type="button" class="sms-atc-bottom smsh-save" style="width:100%;">✓ ADD TO SHEET</button>' +
      '<button type="button" class="smsh-back-link">← Back to sheet</button></div>');
    if (cfg) { cfg.appendChild(panel); cfg.appendChild(editCard); }

    // phone: specs screen options (same groups, pills and footer as single stickers)
    var specsBody = document.querySelector('.sl2-specs-body');
    var specs = h('<div class="smsh-specs">' +
      grp('Sheet size', '<div class="sl2-spec-pills smsh-g3" data-group="size">' + pills('size', SIZE_LIST, S.size, 'sl2-pill') + '</div>') +
      grp('Finish', '<div class="sl2-spec-pills smsh-g3" data-group="finish">' + pills('finish', FINISH_LIST, S.finish, 'sl2-pill') + '</div>') +
      grp('Number of sheets', '<div class="sl2-spec-pills smsh-g6" data-group="sheets">' + pills('sheets', SHEETS_LIST, S.sheets, 'sl2-pill') + '</div>') +
      '</div>');
    if (specsBody) specsBody.appendChild(specs);
    var specsScreen = document.getElementById('sl2Specs');
    var specsPrice = document.getElementById('sl2SpecsPrice'), specsUnit = document.getElementById('sl2SpecsUnit');
    var specsSaved = null;
    // phone: top pill + bottom toolbar while on the sheet
    var builderPill = document.getElementById('sl2SpecsPill');
    var topPill = h('<div class="sl2-specs-pill smsh-toppill" style="display:none;"><span class="smsh-pilltext"></span><span class="smsh-pillprice"></span>' + IC.down + '</div>');
    if (builderPill) builderPill.parentNode.insertBefore(topPill, builderPill.nextSibling); else window.smnLayer().appendChild(topPill);
    var builderTb = document.getElementById('sl2Toolbar');
    var sheetTb = h('<div class="sl2-toolbar smsh-tb">' +
      '<button type="button" class="sl2-tb-btn" data-act="new">' + IC.plus + '<span>Sticker</span></button>' +
      '<label class="sl2-tb-btn">' + IC.upload + '<span>Upload</span>' + FILE_IN + '</label>' +
      '<button type="button" class="sl2-tb-btn" data-act="arrange">' + IC.grid + '<span>Arrange</span></button>' +
      '<button type="button" class="sl2-tb-btn" data-act="fillall">' + IC.copy + '<span>Fill</span></button>' +
      '<button type="button" class="sl2-tb-btn sl2-tb-cart" data-act="cart">' + IC.cart + '<span>Cart</span></button></div>');
    if (builderTb) builderTb.parentNode.insertBefore(sheetTb, builderTb.nextSibling);
    // phone: designing a sticker — slim bar (the right panel isn't visible on phones)
    var editBar = h('<div class="smsh-editbar" hidden role="region" aria-label="Sticker sheet">' +
      '<button type="button" class="smsh-eb-back">← Back to sheet</button>' +
      '<button type="button" class="smsh-eb-save">✓ Add to sheet</button></div>');
    window.smnLayer().appendChild(editBar);

    var $ = function (sel) { return document.querySelector(sel); };
    var $$ = function (sel) { return Array.prototype.slice.call(document.querySelectorAll(sel)); };

    /* the "Single stickers | Sticker sheet" switch (desktop panel + phone specs screen) */
    function addSwitch(host) {
      if (!host || host.querySelector('.smsh-switch')) return;
      var sw = h('<div class="smsh-switch" role="tablist"><button type="button" class="on" role="tab">Single stickers</button><button type="button" role="tab">Sticker sheet <em>NEW</em></button></div>');
      sw.children[0].onclick = function () { if (S.open) closeSheets(); };
      sw.children[1].onclick = function () { if (!S.open) openSheets(); };
      host.insertBefore(sw, host.firstChild);
    }
    addSwitch(cfg);
    addSwitch(specsBody);
    function syncSwitch() {
      $$('.smsh-switch').forEach(function (sw) { sw.children[0].classList.toggle('on', !S.open); sw.children[1].classList.toggle('on', S.open); });
    }

    /* ---------------- canvas ---------------- */
    function initCanvas() {
      if (canvas) return;
      canvas = new fabric.Canvas('smshCanvas', { backgroundColor: '#fff', preserveObjectStacking: true, selection: false });
      canvas.on('after:render', drawGuides);
      canvas.on('selection:created', onSel);
      canvas.on('selection:updated', onSel);
      canvas.on('selection:cleared', onSel);
      canvas.on('object:moving', function (e) { clampInside(e.target); });
      canvas.on('object:scaling', function (e) { syncPhys(e.target); onSel(); });
      canvas.on('object:modified', function (e) { var o = e.target; syncPhys(o); maybeRecontour(o); validate(); onSel(); });
      canvas.on('mouse:dblclick', function (e) { if (e.target && e.target._sh) enterEdit(e.target); });
    }
    // phone: the canvas area runs under the site header, the specs pill and the bottom toolbar,
    // so the sheet stage takes only the space between them
    function fitStage() {
      if (!isPhone()) { stage.style.top = stage.style.bottom = ''; return; }
      var top = 0, bot = 0, area = canvasArea.getBoundingClientRect();
      var hdr = document.querySelector('.sf-header, header, [id*=shopify-section-header]');
      if (hdr) top = Math.max(top, hdr.getBoundingClientRect().bottom);
      if (topPill.style.display !== 'none') top = Math.max(top, topPill.getBoundingClientRect().bottom);
      var tb = sheetTb.getBoundingClientRect(); if (tb.height) bot = Math.max(0, area.bottom - tb.top);
      stage.style.top = Math.max(0, top - area.top) + 'px';
      stage.style.bottom = bot + 'px';
    }
    function layout() {
      if (!canvas) return;
      fitStage();
      var sh = SHEETS[S.size];
      var r = stage.getBoundingClientRect();
      var pad = window.innerWidth < 800 ? 16 : 24;
      // room for the tool bar above the sheet and the selection bar below it (phone: selection bar only)
      var np = Math.max(10, Math.min((r.width - pad * 2) / sh.w, (r.height - pad * 2 - (isPhone() ? 56 : 92)) / sh.h));
      var f = np / ppi;
      ppi = np;
      canvas.setDimensions({ width: Math.round(sh.w * ppi), height: Math.round(sh.h * ppi) });
      paper.style.borderRadius = Math.max(4, 0.125 * ppi) + 'px';
      items().forEach(function (o) {
        o.set({ left: o.left * f, top: o.top * f });
        applyScale(o);
      });
      validate();
      canvas.requestRenderAll();
    }
    function items() { return canvas ? canvas.getObjects().filter(function (o) { return o._sh; }) : []; }

    function drawGuides() {
      if (hideGuides) return;
      var ctx = canvas.getContext(), sh = SHEETS[S.size], m = MARGIN * ppi;
      ctx.save();
      ctx.setLineDash([4, 4]); ctx.lineWidth = 1; ctx.strokeStyle = 'rgba(40,147,242,.35)';
      ctx.strokeRect(m, m, sh.w * ppi - 2 * m, sh.h * ppi - 2 * m);
      ctx.setLineDash([]);
      items().forEach(function (o) {
        var poly = polyPx(o, 2);
        ctx.beginPath();
        poly.forEach(function (p, i) { i ? ctx.lineTo(p.x, p.y) : ctx.moveTo(p.x, p.y); });
        ctx.closePath();
        ctx.lineWidth = o._bad ? 2.5 : 1.2;
        ctx.strokeStyle = o._bad ? '#ef4444' : 'rgba(236,72,153,.85)';
        ctx.shadowColor = 'rgba(15,23,42,.18)'; ctx.shadowBlur = o._bad ? 0 : 6;
        ctx.stroke();
      });
      ctx.restore();
    }

    /* ---------------- geometry ---------------- */
    // cut points of an item in canvas px (every `step`-th point)
    function polyPx(o, step) {
      var m = o.calcTransformMatrix(), pts = o._sh.pts, out = [], hw = o.width / 2, hh = o.height / 2;
      for (var i = 0; i < pts.length; i += (step || 1)) {
        out.push(fabric.util.transformPoint(new fabric.Point(pts[i][0] - hw, pts[i][1] - hh), m));
      }
      return out;
    }
    function bbox(poly) {
      var b = { l: 1e9, t: 1e9, r: -1e9, b: -1e9 };
      poly.forEach(function (p) { b.l = Math.min(b.l, p.x); b.t = Math.min(b.t, p.y); b.r = Math.max(b.r, p.x); b.b = Math.max(b.b, p.y); });
      return b;
    }
    // the sticker's real footprint: bounds of its cut line (tighter than the image box when rotated)
    function cutBox(o) {
      var b = bbox(polyPx(o, 1));
      return { left: b.l, top: b.t, width: b.r - b.l, height: b.b - b.t };
    }
    function segDist(p, a, b) {
      var dx = b.x - a.x, dy = b.y - a.y, L = dx * dx + dy * dy, t = L ? ((p.x - a.x) * dx + (p.y - a.y) * dy) / L : 0;
      t = Math.max(0, Math.min(1, t));
      var x = a.x + t * dx - p.x, y = a.y + t * dy - p.y;
      return Math.sqrt(x * x + y * y);
    }
    function inside(p, poly) {
      var c = false;
      for (var i = 0, j = poly.length - 1; i < poly.length; j = i++) {
        var a = poly[i], b = poly[j];
        if ((a.y > p.y) !== (b.y > p.y) && p.x < (b.x - a.x) * (p.y - a.y) / (b.y - a.y) + a.x) c = !c;
      }
      return c;
    }
    function tooClose(A, B, gap) {
      var ba = bbox(A), bb = bbox(B);
      if (ba.r + gap < bb.l || bb.r + gap < ba.l || ba.b + gap < bb.t || bb.b + gap < ba.t) return false;
      if (inside(A[0], B) || inside(B[0], A)) return true;
      function near(P, Q) {
        for (var i = 0; i < P.length; i++) for (var j = 0; j < Q.length; j++) {
          if (segDist(P[i], Q[j], Q[(j + 1) % Q.length]) < gap) return true;
        }
        return false;
      }
      return near(A, B) || near(B, A);
    }
    function validate() {
      var its = items(), sh = SHEETS[S.size], m = MARGIN * ppi, W = sh.w * ppi, H = sh.h * ppi, g = GAP * ppi;
      var polys = its.map(function (o) { return polyPx(o, 3); });
      var nOut = 0, nOver = 0;
      its.forEach(function (o, i) {
        var b = bbox(polys[i]);
        var out = b.l < m - 0.5 || b.t < m - 0.5 || b.r > W - m + 0.5 || b.b > H - m + 0.5;
        var over = false;
        for (var j = 0; j < its.length && !over; j++) if (j !== i && tooClose(polys[i], polys[j], g)) over = true;
        o._bad = out || over;
        if (out) nOut++;
        if (over) nOver++;
      });
      var w = $('.smsh-warn');
      var msg = [];
      if (nOver) msg.push(nOver + ' sticker' + (nOver > 1 ? 's are' : ' is') + ' too close to another (keep 1/8″ between cut lines)');
      if (nOut) msg.push(nOut + ' sticker' + (nOut > 1 ? 's go' : ' goes') + ' past the safe area');
      w.textContent = msg.join(' · ');
      w.hidden = !msg.length;
      if (msg.length && hasCopies()) {
        var kb = document.createElement('button'); kb.type = 'button'; kb.className = 'smsh-keep'; kb.textContent = 'Keep what fits';
        kb.onclick = trimToFit; w.appendChild(kb);
      }
      updateCount();
      return !(nOut || nOver);
    }
    function clampInside(o) {
      var sh = SHEETS[S.size], m = MARGIN * ppi;
      o.setCoords();
      var b = cutBox(o);
      var dx = 0, dy = 0;
      if (b.left < m) dx = m - b.left; else if (b.left + b.width > sh.w * ppi - m) dx = sh.w * ppi - m - b.left - b.width;
      if (b.top < m) dy = m - b.top; else if (b.top + b.height > sh.h * ppi - m) dy = sh.h * ppi - m - b.top - b.height;
      if (b.width <= sh.w * ppi - 2 * m && dx) o.left += dx;
      if (b.height <= sh.h * ppi - 2 * m && dy) o.top += dy;
    }

    /* ---------------- contour ---------------- */
    function smooth(pts, passes) {
      for (var p = 0; p < passes; p++) {
        var n = pts.length, o = new Array(n);
        for (var i = 0; i < n; i++) {
          var a = pts[(i - 2 + n) % n], b = pts[(i - 1 + n) % n], c = pts[i], d = pts[(i + 1) % n], e = pts[(i + 2) % n];
          o[i] = [(a[0] + b[0] + c[0] + d[0] + e[0]) / 5, (a[1] + b[1] + c[1] + d[1] + e[1]) / 5];
        }
        pts = o;
      }
      return pts;
    }
    function rdp(pts, eps) {
      if (pts.length < 3) return pts;
      var keep = new Uint8Array(pts.length); keep[0] = keep[pts.length - 1] = 1;
      var stack = [[0, pts.length - 1]];
      while (stack.length) {
        var s = stack.pop(), a = pts[s[0]], b = pts[s[1]], md = 0, mi = -1;
        for (var i = s[0] + 1; i < s[1]; i++) {
          var d = segDist({ x: pts[i][0], y: pts[i][1] }, { x: a[0], y: a[1] }, { x: b[0], y: b[1] });
          if (d > md) { md = d; mi = i; }
        }
        if (md > eps) { keep[mi] = 1; stack.push([s[0], mi], [mi, s[1]]); }
      }
      return pts.filter(function (_, i) { return keep[i]; });
    }
    function rectContour(src, off) {
      var pad = Math.ceil(off) + 2, cw = src.width + pad * 2, ch = src.height + pad * 2;
      var cv = document.createElement('canvas'); cv.width = cw; cv.height = ch;
      var cx = cv.getContext('2d'), r = off * 1.2;
      var x0 = pad - off, y0 = pad - off, w = src.width + off * 2, hh = src.height + off * 2;
      function rr(c) {
        c.beginPath(); c.moveTo(x0 + r, y0); c.arcTo(x0 + w, y0, x0 + w, y0 + hh, r); c.arcTo(x0 + w, y0 + hh, x0, y0 + hh, r);
        c.arcTo(x0, y0 + hh, x0, y0, r); c.arcTo(x0, y0, x0 + w, y0, r); c.closePath();
      }
      rr(cx); cx.fillStyle = '#fff'; cx.fill();
      cx.drawImage(src, pad, pad);
      // outline: four quarter arcs joined by the straight edges (clockwise from top-left)
      var pts = [], corners = [[x0 + w - r, y0 + r, -90], [x0 + w - r, y0 + hh - r, 0], [x0 + r, y0 + hh - r, 90], [x0 + r, y0 + r, 180]];
      corners.forEach(function (c) {
        for (var a = 0; a <= 90; a += 10) {
          var t = (c[2] + a) * Math.PI / 180;
          pts.push([c[0] + Math.cos(t) * r, c[1] + Math.sin(t) * r]);
        }
      });
      return { canvas: cv, pts: pts };
    }
    function contourFor(src, physIn) {
      var pxPerIn = Math.max(src.width, src.height) / physIn;
      var off = Math.max(2, BORDER_MM[S.border] / 25.4 * pxPerIn);
      var r = window._groupedContour ? window._groupedContour(src, off) : null;
      if (!r || !r.cutPts) { var rc = rectContour(src, off); return { canvas: rc.canvas, pts: rc.pts, opaque: true }; }
      var pts = r.cutPts.map(function (p) { return [p[0] + r.offsetX, p[1] + r.offsetY]; });
      pts = rdp(smooth(pts, 2), Math.max(0.6, 0.004 * pxPerIn));
      return { canvas: r.canvas, pts: pts, opaque: false };
    }
    function applyScale(o) {
      var s = o._sh.fixed ? ppi * o._sh.physW / o.width : ppi * o._sh.phys / Math.max(o._sh.src.width, o._sh.src.height);
      o.set({ scaleX: s, scaleY: s }); o.setCoords();
    }
    function syncPhys(o) { if (o && o._sh && !o._sh.fixed) o._sh.phys = o.scaleX * Math.max(o._sh.src.width, o._sh.src.height) / ppi; }
    function recontour(o) {
      if (o._sh.fixed) return;
      var c = contourFor(o._sh.src, o._sh.phys);
      o.setElement(c.canvas);
      o._sh.pts = c.pts; o._sh.basis = o._sh.phys; o._sh.opaque = c.opaque; o._sh.border = S.border;
      applyScale(o);
    }
    function maybeRecontour(o) {
      if (o && o._sh && !o._sh.fixed && Math.abs(o._sh.phys / o._sh.basis - 1) > 0.2) recontour(o);
    }

    /* ---------------- items ---------------- */
    function newImage(el, sh, angle) {
      var o = new fabric.Image(el, {
        originX: 'center', originY: 'center', angle: angle || 0, lockSkewingX: true, lockSkewingY: true, lockScalingFlip: true,
        lockScalingX: !!sh.fixed, lockScalingY: !!sh.fixed,
        cornerStyle: 'circle', cornerColor: '#007AFF', borderColor: '#007AFF', transparentCorners: false, cornerSize: 12
      });
      o.setControlsVisibility(sh.fixed ? { mt: false, mb: false, ml: false, mr: false, tl: false, tr: false, bl: false, br: false }
        : { mt: false, mb: false, ml: false, mr: false });
      o._sh = sh;
      applyScale(o);
      return o;
    }
    function makeItem(src, phys, shared) {
      var c = shared || contourFor(src, phys);
      return newImage(c.canvas, { src: src, pts: c.pts, phys: phys, basis: phys, opaque: c.opaque, border: S.border });
    }
    function freeSpot(o) {
      // first top-left position (0.1″ grid) where this item's box keeps GAP from every other box
      var sh = SHEETS[S.size], m = MARGIN * ppi, g = (GAP + 0.02) * ppi, step = 0.1 * ppi;
      o.set({ left: 0, top: 0 }); o.setCoords();
      var b0 = cutBox(o), offX = o.left - b0.left, offY = o.top - b0.top;
      var boxes = items().filter(function (x) { return x !== o; }).map(cutBox);
      for (var y = m; y + b0.height <= sh.h * ppi - m + 0.5; y += step) {
        for (var x = m; x + b0.width <= sh.w * ppi - m + 0.5; x += step) {
          var hit = boxes.some(function (b) { return x < b.left + b.width + g && b.left < x + b0.width + g && y < b.top + b.height + g && b.top < y + b0.height + g; });
          if (!hit) { o.set({ left: x + offX, top: y + offY }); o.setCoords(); return true; }
        }
      }
      return false;
    }
    function add(o, select) {
      canvas.add(o);
      if (!freeSpot(o)) {
        var sh = SHEETS[S.size];
        o.set({ left: sh.w * ppi / 2, top: sh.h * ppi / 2 }); o.setCoords();
      }
      if (select) canvas.setActiveObject(o);
    }
    function duplicate(o) {
      var c = newImage(o.getElement(), Object.assign({}, o._sh), o.angle);
      canvas.add(c);
      if (!freeSpot(c)) { canvas.remove(c); return null; }
      return c;
    }
    // MaxRects packing of the stickers' cut-line boxes (px), GAP between them, inside the safe area.
    // Returns top-left positions (safe-area px) or null when they don't all fit.
    function pack(sizes) {
      var sh = SHEETS[S.size], g = (GAP + 0.02) * ppi, W = sh.w * ppi - 2 * MARGIN * ppi + g, H = sh.h * ppi - 2 * MARGIN * ppi + g;
      var free = [{ x: 0, y: 0, w: W, h: H }], out = new Array(sizes.length);
      var order = sizes.map(function (z, i) { return i; }).sort(function (a, b) {
        return Math.max(sizes[b].w, sizes[b].h) - Math.max(sizes[a].w, sizes[a].h) || sizes[b].w * sizes[b].h - sizes[a].w * sizes[a].h;
      });
      for (var k = 0; k < order.length; k++) {
        var idx = order[k], rw = sizes[idx].w + g, rh = sizes[idx].h + g, best = null;
        for (var f = 0; f < free.length; f++) {
          var fr = free[f];
          if (rw <= fr.w + 0.01 && rh <= fr.h + 0.01 && (!best || fr.y < best.y - 0.5 || (Math.abs(fr.y - best.y) <= 0.5 && fr.x < best.x))) best = { x: fr.x, y: fr.y };
        }
        if (!best) return null;
        out[idx] = best;
        var pl = { x: best.x, y: best.y, w: rw, h: rh }, next = [];
        free.forEach(function (fr) {
          if (pl.x >= fr.x + fr.w || pl.x + pl.w <= fr.x || pl.y >= fr.y + fr.h || pl.y + pl.h <= fr.y) { next.push(fr); return; }
          if (pl.x > fr.x) next.push({ x: fr.x, y: fr.y, w: pl.x - fr.x, h: fr.h });
          if (pl.x + pl.w < fr.x + fr.w) next.push({ x: pl.x + pl.w, y: fr.y, w: fr.x + fr.w - pl.x - pl.w, h: fr.h });
          if (pl.y > fr.y) next.push({ x: fr.x, y: fr.y, w: fr.w, h: pl.y - fr.y });
          if (pl.y + pl.h < fr.y + fr.h) next.push({ x: fr.x, y: pl.y + pl.h, w: fr.w, h: fr.y + fr.h - pl.y - pl.h });
        });
        free = next.filter(function (a, ia) {
          return a.w > 0.5 && a.h > 0.5 && !next.some(function (b, ib) {
            return ib !== ia && b.x <= a.x && b.y <= a.y && b.x + b.w >= a.x + a.w && b.y + b.h >= a.y + a.h && (ib < ia || b.w * b.h > a.w * a.h);
          });
        });
      }
      return out;
    }
    // place every sticker from a packing, with the whole group centred on the sheet
    function applyPack(its, boxes, pos) {
      var sh = SHEETS[S.size], m = MARGIN * ppi, r = 0, b = 0;
      pos.forEach(function (p, i) { r = Math.max(r, p.x + boxes[i].width); b = Math.max(b, p.y + boxes[i].height); });
      var ox = m + Math.max(0, (sh.w * ppi - 2 * m - r) / 2), oy = m + Math.max(0, (sh.h * ppi - 2 * m - b) / 2);
      its.forEach(function (o, i) {
        o.set({ left: o.left + (ox + pos[i].x - boxes[i].left), top: o.top + (oy + pos[i].y - boxes[i].top) }); o.setCoords();
      });
    }
    function arrange(quiet) {
      var its = items(); if (!its.length) return false;
      var boxes = its.map(cutBox), pos = pack(boxes.map(function (b) { return { w: b.width, h: b.height }; }));
      if (!pos) { if (!quiet) toast('These stickers don’t all fit — make some smaller or pick a bigger sheet', 'warn'); validate(); return false; }
      applyPack(its, boxes, pos);
      validate(); canvas.requestRenderAll();
      return true;
    }
    // add as many copies as fit (round-robin over the given stickers), then pack + centre everything
    function fillCopies(sources) {
      var its = items(), sizes = its.map(function (o) { var b = cutBox(o); return { w: b.width, h: b.height }; });
      var src = sources.map(function (o) { var b = cutBox(o); return { o: o, sz: { w: b.width, h: b.height }, n: 0, done: false }; });
      if (!pack(sizes)) { toast('Fix the layout first — these stickers don’t all fit', 'warn'); return 0; }
      var total = 0, guard = 0;
      while (guard++ < 400 && src.some(function (x) { return !x.done; })) {
        src.forEach(function (x) {
          if (x.done) return;
          if (pack(sizes.concat([x.sz]))) { sizes.push(x.sz); x.n++; total++; } else x.done = true;
        });
      }
      src.forEach(function (x) {
        for (var k = 0; k < x.n; k++) { var c = newImage(x.o.getElement(), Object.assign({}, x.o._sh), x.o.angle); c.set({ left: x.o.left, top: x.o.top }); canvas.add(c); }
      });
      arrange(true);
      return total;
    }
    function fillWith(o) { return fillCopies([o]); }
    function hasCopies() {
      var its = items();
      return its.some(function (o) { return its.some(function (x) { return x !== o && x.getElement() === o.getElement(); }); });
    }
    // drop extra copies (never a sticker's last copy), newest first, until everything packs
    function trimToFit() {
      var removed = 0, list = items();
      for (var i = list.length - 1; i >= 0 && !arrange(true); i--) {
        var o = list[i];
        if (items().some(function (x) { return x !== o && x.getElement() === o.getElement(); })) { canvas.remove(o); removed++; }
      }
      arrange(true); validate(); onSel(); updateEmpty(); canvas.requestRenderAll();
      toast(removed ? 'Removed ' + removed + ' extra cop' + (removed > 1 ? 'ies' : 'y') : 'Nothing to remove — make some stickers smaller', removed ? '' : 'warn');
    }
    // after a sheet-size change: re-arrange; if they no longer fit, offer to drop extra copies
    function fitToSheet() {
      if (!items().length) return;
      if (arrange(true)) return;
      if (!hasCopies()) { toast('These stickers don’t fit on a ' + SHEETS[S.size].label + ' sheet — make some smaller or pick a bigger sheet', 'warn'); return; }
      toast('Not everything fits on a ' + SHEETS[S.size].label + ' sheet', 'warn', { label: 'Keep what fits', fn: trimToFit });
    }
    function loadImage(file) {
      return new Promise(function (res, rej) {
        var u = URL.createObjectURL(file), im = new Image();
        im.onload = function () { res(im); };
        im.onerror = function () { URL.revokeObjectURL(u); rej(new Error('Could not read ' + file.name)); };
        im.src = u;
      });
    }
    function toSrcCanvas(im) {
      var w = im.naturalWidth || im.width, hh = im.naturalHeight || im.height, k = Math.min(1, SRC_MAX / Math.max(w, hh));
      var c = document.createElement('canvas'); c.width = Math.round(w * k); c.height = Math.round(hh * k);
      var x = c.getContext('2d'); x.imageSmoothingQuality = 'high'; x.drawImage(im, 0, 0, c.width, c.height);
      return c;
    }
    async function addFiles(files) {
      initCanvas(); layout();
      var list = Array.prototype.slice.call(files || []), added = 0;
      for (var i = 0; i < list.length; i++) {
        var f = list[i];
        if (/hei[cf]/i.test(f.type) || /\.hei[cf]$/i.test(f.name)) { toast(f.name + ': HEIC photos aren’t supported — export as JPG or PNG', 'warn'); continue; }
        if (!/^image\/(png|jpe?g|webp|gif|svg\+xml)$/i.test(f.type)) { toast(f.name + ': use a PNG, JPG, SVG or WEBP image', 'warn'); continue; }
        try {
          var src = toSrcCanvas(await loadImage(f));
          var sh = SHEETS[S.size];
          var phys = Math.min(2, Math.min(sh.w, sh.h) - 2 * MARGIN - 0.4);
          var o = makeItem(src, phys);
          add(o, i === list.length - 1);
          added++;
          if (o._sh.opaque) toast(f.name + ' has no transparent background — it will be cut as a rounded rectangle. Tap “Remove bg” to cut around the subject.', 'warn');
        } catch (e) { toast(e.message, 'warn'); }
      }
      if (added) { validate(); onSel(); canvas.requestRenderAll(); }
      updateEmpty();
    }
    // crop a canvas to its visible (non-transparent) pixels
    function trimAlpha(c) {
      var x = c.getContext('2d'), d = x.getImageData(0, 0, c.width, c.height).data, l = c.width, t = c.height, r = -1, bm = -1;
      for (var y = 0; y < c.height; y++) for (var xx = 0; xx < c.width; xx++) {
        if (d[(y * c.width + xx) * 4 + 3] > 8) { if (xx < l) l = xx; if (xx > r) r = xx; if (y < t) t = y; if (y > bm) bm = y; }
      }
      if (r < 0 || (l === 0 && t === 0 && r === c.width - 1 && bm === c.height - 1)) return c;
      var o = document.createElement('canvas'); o.width = r - l + 1; o.height = bm - t + 1;
      o.getContext('2d').drawImage(c, l, t, o.width, o.height, 0, 0, o.width, o.height);
      return o;
    }
    async function removeBg(o) {
      var btn = selBar.querySelector('[data-act=bg]');
      btn.disabled = true; btn.textContent = 'Removing…';
      try {
        var blob = await new Promise(function (r) { o._sh.src.toBlob(r, 'image/png'); });
        var r = await fetch(WORKER + '/bg-remove', { method: 'POST', headers: { 'Content-Type': 'image/png' }, body: blob });
        if (!r.ok) throw new Error('Background removal failed (' + r.status + ')');
        var im = await loadImage(await r.blob());
        o._sh.src = trimAlpha(toSrcCanvas(im));
        recontour(o);
        validate(); canvas.requestRenderAll(); onSel();
        if (o._sh.opaque) toast('Couldn’t find a clear subject — kept the rectangle cut', 'warn');
      } catch (e) { toast(e.message, 'warn'); }
      btn.disabled = false; btn.textContent = 'Remove bg';
    }

    /* ---------------- UI state ---------------- */
    function onSel() {
      var o = canvas && canvas.getActiveObject();
      selBar.hidden = !(o && o._sh);
      if (!o || !o._sh) return;
      var sh = SHEETS[S.size];
      sizeIn.max = String(Math.min(sh.w, sh.h) - 2 * MARGIN - 0.2);
      sizeIn.hidden = !!o._sh.fixed;
      var b = cutBox(o);
      if (!o._sh.fixed && document.activeElement !== sizeIn) sizeIn.value = (Math.max(b.width, b.height) / ppi).toFixed(2);
      selBar.querySelector('.smsh-size b').textContent = (b.width / ppi).toFixed(2) + '″ × ' + (b.height / ppi).toFixed(2) + '″';
      selBar.querySelector('[data-act=bg]').hidden = !o._sh.opaque || !!o._sh.fixed;
    }
    function updateEmpty() { stage.querySelector('.smsh-empty').hidden = items().length > 0; }
    function updateCount() {
      var n = items().length;
      $('.smsh-count').textContent = n ? n + ' sticker' + (n > 1 ? 's' : '') + ' · ' + SHEETS[S.size].label : SHEETS[S.size].label;
      updatePrice();
    }
    function updatePrice() {
      var t = sheetTotal(S.size, S.finish, S.sheets), n = items().length;
      var each = '$' + (t / S.sheets).toFixed(2) + '/sheet' + (n ? ' · $' + (t / S.sheets / n).toFixed(2) + '/sticker' : '');
      $$('.smsh-total').forEach(function (e) { e.textContent = '$' + t.toFixed(2); });
      $$('.smsh-each').forEach(function (e) { e.textContent = S.sheets + ' sheet' + (S.sheets > 1 ? 's' : '') + ' · ' + each; });
      topPill.querySelector('.smsh-pilltext').textContent = SHEETS[S.size].label + ' • ' + ({ matte: 'Matte', glossy: 'Glossy', holographic: 'Holo' })[S.finish] + ' • ' + S.sheets + ' sheet' + (S.sheets > 1 ? 's' : '');
      topPill.querySelector('.smsh-pillprice').textContent = '$' + t.toFixed(2);
      if (S.open && specsPrice) { specsPrice.textContent = '$' + t.toFixed(2); if (specsUnit) specsUnit.textContent = '$' + (t / S.sheets).toFixed(2) + ' per sheet'; }
    }
    function setPill(group, val) {
      $$('[data-group=' + group + '] [data-' + group + ']').forEach(function (b) {
        var on = b.dataset[group] === String(val);
        b.classList.toggle('on', on); b.classList.toggle('active', on);
      });
    }

    function onClick(e) {
      var b = e.target.closest('button'); if (!b) return;
      var o = canvas && canvas.getActiveObject();
      if (b.dataset.size) {
        S.size = b.dataset.size; setPill('size', S.size); initCanvas(); layout();
        fitToSheet(); validate(); updatePrice(); canvas.requestRenderAll();
      } else if (b.dataset.finish) {
        S.finish = b.dataset.finish; setPill('finish', S.finish); updatePrice();
      } else if (b.dataset.sheets) {
        S.sheets = +b.dataset.sheets; setPill('sheets', S.sheets); $$('.smsh-qty').forEach(function (q) { q.value = ''; }); updatePrice();
      } else if (b.dataset.act === 'new') { enterEdit(null); }
      else if (b.dataset.act === 'cart') { addToCart(b); }
      else if (b.dataset.act === 'arrange') { if (!items().length) return toast('Add a sticker first', 'warn'); arrange(); }
      else if (b.dataset.act === 'fillall') {
        var its = items(); if (!its.length) return toast('Add a sticker first', 'warn');
        // one copy-source per distinct design (copies share their design's image)
        var seen = [], srcs = its.filter(function (x) { var el = x.getElement(); if (seen.indexOf(el) > -1) return false; seen.push(el); return true; });
        var k = fillCopies(srcs);
        canvas.requestRenderAll(); toast(k ? 'Added ' + k + ' copies' : 'The sheet is already full');
      }
      else if (!o || !o._sh) { /* nothing selected */ }
      else if (b.dataset.act === 'edit') { enterEdit(o); }
      else if (b.dataset.act === 'dup') { var c = duplicate(o); if (c) canvas.setActiveObject(c); else toast('No free space left on the sheet', 'warn'); validate(); canvas.requestRenderAll(); }
      else if (b.dataset.act === 'fill') { var n = fillWith(o); canvas.requestRenderAll(); onSel(); toast(n ? 'Added ' + n + ' copies' : 'No free space left on the sheet', n ? '' : 'warn'); }
      else if (b.dataset.act === 'rot') { o.rotate(((o.angle || 0) + 90) % 360); o.setCoords(); clampInside(o); validate(); canvas.requestRenderAll(); onSel(); }
      else if (b.dataset.act === 'bg') { removeBg(o); }
      else if (b.dataset.act === 'del') { canvas.remove(o); canvas.discardActiveObject(); validate(); canvas.requestRenderAll(); onSel(); updateEmpty(); }
    }
    [stage, panel, specs, sheetTb].forEach(function (el) { el.addEventListener('click', onClick); });
    panel.querySelector('.smsh-atc').addEventListener('click', function () { addToCart(this); });
    sizeIn.addEventListener('input', function () {
      var o = canvas.getActiveObject(); if (!o || !o._sh) return;
      var b = cutBox(o), cur = Math.max(b.width, b.height) / ppi;
      if (cur > 0) { o._sh.phys *= (+sizeIn.value) / cur; applyScale(o); clampInside(o); canvas.requestRenderAll(); onSel(); }
    });
    sizeIn.addEventListener('change', function () {
      var o = canvas.getActiveObject(); if (!o || !o._sh) return;
      maybeRecontour(o); validate(); canvas.requestRenderAll();
    });
    $$('.smsh-qty').forEach(function (q) {
      q.addEventListener('input', function () {
        if (!this.value) return;
        S.sheets = Math.max(1, Math.min(1000, parseInt(this.value, 10) || 1)); setPill('sheets', -1); updatePrice();
      });
      q.addEventListener('change', function () { if (this.value) this.value = String(S.sheets); });
    });
    [stage, panel, sheetTb].forEach(function (el) {
      el.querySelectorAll('input[type=file]').forEach(function (inp) {
        inp.addEventListener('change', function () { addFiles(inp.files); inp.value = ''; });
      });
    });
    stage.addEventListener('dragover', function (e) { e.preventDefault(); stage.classList.add('drag'); });
    stage.addEventListener('dragleave', function () { stage.classList.remove('drag'); });
    stage.addEventListener('drop', function (e) { e.preventDefault(); stage.classList.remove('drag'); addFiles(e.dataTransfer.files); });

    // the builder's left toolbar works on the sheet: a tool starts a new sticker with that tool;
    // with a sticker selected, it opens that sticker in the designer first
    var toolstrip = document.querySelector('.sms-toolstrip');
    if (toolstrip) toolstrip.addEventListener('click', function (e) {
      if (!html.classList.contains('smsh-view') || html.classList.contains('smsh-editing')) return;
      var t = e.target.closest('button, label'); if (!t) return;
      var o = canvas && canvas.getActiveObject();
      if (o && o._sh) { e.preventDefault(); e.stopImmediatePropagation(); enterEdit(o); return; }
      enterEdit(null); // the same click then reaches the builder's tool
    }, true);

    // phone: "Start designing" on the specs screen opens the sheet
    var startBtn = document.getElementById('sl2StartDesigning');
    if (startBtn) startBtn.addEventListener('click', function (e) {
      if (!S.open) return;
      e.preventDefault(); e.stopImmediatePropagation();
      if (specsScreen) specsScreen.style.display = 'none';
      showView();
    }, true);
    topPill.addEventListener('click', function () {
      html.classList.remove('smsh-view');
      topPill.style.display = 'none';
      if (specsScreen) specsScreen.style.display = '';
    });

    // keys go to the sheet (not the builder canvas underneath) while it is shown
    window.addEventListener('keydown', function (e) {
      if (!html.classList.contains('smsh-view') || html.classList.contains('smsh-editing')) return;
      var t = e.target;
      if (t && (t.tagName === 'INPUT' || t.tagName === 'TEXTAREA' || t.isContentEditable)) return;
      var o = canvas && canvas.getActiveObject();
      if ((e.key === 'Delete' || e.key === 'Backspace') && o && o._sh) {
        canvas.remove(o); canvas.discardActiveObject(); validate(); canvas.requestRenderAll(); onSel(); updateEmpty();
      } else if (e.key === 'Escape') { canvas && canvas.discardActiveObject(); canvas && canvas.requestRenderAll(); onSel(); }
      else if ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === 'd' && o && o._sh) { var c = duplicate(o); if (c) canvas.setActiveObject(c); validate(); canvas.requestRenderAll(); }
      else return;
      e.preventDefault(); e.stopImmediatePropagation();
    }, true);
    window.addEventListener('resize', function () { if (html.classList.contains('smsh-view')) layout(); });
    window.addEventListener('beforeunload', function (e) { if (S.open && items().length) { e.preventDefault(); e.returnValue = ''; } });

    /* ---------------- modes ---------------- */
    function snapshot() {
      var c = B.canvas;
      if (!c || !SMN.vo().length) return null;
      return { canvas: c.toJSON(['_isCutline', '_isCutEdge', '_isMainImage', '_isTemplateBg', '_uid']), cw: c.width, ch: c.height,
        size: B.size, sizeInches: B.sizeInches, qty: B.qty, finish: B.finish, shape: B.shape, cutStyle: B.cutStyle,
        smoothLevel: B.smoothLevel, bgMode: B.bgMode, borderColor: B.borderColor, shapePortrait: B.shapePortrait };
    }
    function loadDesign(snap) {
      window._smnSheetLoad = true;
      SMN.applyRemote(snap, false);
      setTimeout(function () { window._smnSheetLoad = false; }, 1500);
    }
    function clearBuilder() { var so = document.getElementById('btnStartOver'); if (so) so.click(); }

    function showView() {
      html.classList.add('smsh-view');
      if (isPhone()) topPill.style.display = 'flex';
      initCanvas();
      requestAnimationFrame(function () { layout(); updateEmpty(); updateCount(); onSel(); });
      setTimeout(layout, 80);
    }
    function openSheets() {
      if (S.open) return;
      singleSnap = snapshot(); singleShare = SMN.shareId && SMN.shareId(); window._smnNoAutosave = true;
      S.open = true;
      html.classList.add('smsh-on');
      syncSwitch();
      if (specsPrice && !specsSaved) specsSaved = [specsPrice.textContent, specsUnit ? specsUnit.textContent : ''];
      updatePrice();
      // desktop shows the sheet at once; on a phone the specs screen comes first, like single stickers
      if (!isPhone() || !specsScreen || specsScreen.style.display === 'none') {
        if (specsScreen && isPhone()) specsScreen.style.display = 'none';
        clearBuilder();
        showView();
      }
    }
    function closeSheets() {
      if (!S.open) return;
      S.open = false;
      exitEditUI();
      html.classList.remove('smsh-on', 'smsh-view');
      topPill.style.display = 'none';
      syncSwitch();
      if (specsSaved && specsPrice) { specsPrice.textContent = specsSaved[0]; if (specsUnit) specsUnit.textContent = specsSaved[1]; }
      specsSaved = null;
      // put the customer's own single-sticker design back
      clearBuilder();
      if (singleSnap) loadDesign(singleSnap);
      if (singleShare && SMN.setShareId) SMN.setShareId(singleShare);
      singleSnap = null; singleShare = null;
      window._smnNoAutosave = false;
    }

    /* ---------------- designing a sheet sticker in the builder ---------------- */
    function exitEditUI() {
      editing = null; editBar.hidden = true;
      html.classList.remove('smsh-editing');
    }
    function enterEdit(item) {
      editing = item || 'new';
      html.classList.add('smsh-editing');
      html.classList.remove('smsh-view');
      topPill.style.display = 'none';
      if (isPhone()) { editBar.hidden = false; editBar.style.removeProperty('display'); }
      $$('.smsh-save, .smsh-eb-save').forEach(function (b) { b.textContent = item ? '✓ UPDATE SHEET' : '✓ ADD TO SHEET'; });
      clearBuilder();
      if (item && item._sh.design) setTimeout(function () { loadDesign(item._sh.design); }, 60);
      else if (item && item._sh.src) {
        // a quick upload: open its image in the designer
        item._sh.src.toBlob(function (blob) {
          var fi = document.getElementById('fileInput'); if (!fi || !blob) return;
          var dt = new DataTransfer(); dt.items.add(new File([blob], 'sticker.png', { type: 'image/png' }));
          fi.files = dt.files; fi.dispatchEvent(new Event('change', { bubbles: true }));
        }, 'image/png');
      }
    }
    function backToSheet() {
      exitEditUI();
      clearBuilder();
      showView();
    }
    async function saveEdit(e) {
      var btns = $$('.smsh-save, .smsh-eb-save');
      if (!SMN.vo().length) return toast('Add an image, text or clipart first', 'warn');
      var labels = btns.map(function (b) { return b.textContent; });
      btns.forEach(function (b) { b.disabled = true; b.textContent = 'Preparing…'; });
      function restore() { btns.forEach(function (b, i) { b.disabled = false; b.textContent = labels[i]; }); }
      try {
        window._smnPrintParts = null;
        var snap = snapshot();
        var pdf = await SMN.printPDF();
        var parts = window._smnPrintParts;
        if (!pdf || !parts) throw new Error('Could not prepare this sticker — try again');
        var im = await new Promise(function (res, rej) {
          var u = URL.createObjectURL(parts.blob), x = new Image();
          x.onload = function () { res(x); }; x.onerror = function () { rej(new Error('Could not read the sticker image')); }; x.src = u;
        });
        var el = document.createElement('canvas'); el.width = im.naturalWidth; el.height = im.naturalHeight;
        el.getContext('2d').drawImage(im, 0, 0);
        var k = el.width / parts.ptW;
        var pts = parts.cut.map(function (p) { return [(p[0] + parts.bPt) * k, (p[1] + parts.bPt) * k]; });
        pts = rdp(pts, Math.max(0.5, el.width / (parts.ptW / 72) * 0.003));
        var physW = parts.ptW / 72, physH = parts.ptH / 72, sh = SHEETS[S.size];
        var room = Math.min(sh.w, sh.h) - 2 * MARGIN, roomL = Math.max(sh.w, sh.h) - 2 * MARGIN;
        if (Math.min(physW, physH) > room || Math.max(physW, physH) > roomL) {
          throw new Error('This sticker (' + physW.toFixed(1) + '″ × ' + physH.toFixed(1) + '″) is too big for a ' + sh.label + ' sheet — pick a smaller size');
        }
        initCanvas();
        var data = { fixed: true, design: snap, pts: pts, physW: physW, opaque: false };
        if (editing && editing !== 'new' && canvas.getObjects().indexOf(editing) > -1) {
          var o = editing;
          o.setElement(el); o._sh = data; applyScale(o); clampInside(o);
          canvas.setActiveObject(o);
        } else {
          add(newImage(el, data), true);
        }
        validate(); canvas.requestRenderAll();
        restore();
        backToSheet();
      } catch (err) {
        restore();
        toast(err.message || 'Something went wrong', 'warn');
      }
    }
    editBar.querySelector('.smsh-eb-back').onclick = backToSheet;
    editBar.querySelector('.smsh-eb-save').onclick = saveEdit;
    editCard.querySelector('.smsh-back-link').onclick = backToSheet;
    editCard.querySelector('.smsh-save').onclick = saveEdit;

    /* ---------------- print file ---------------- */
    function bezOps(P, pts) {
      // closed Catmull-Rom through the points → cubic Béziers
      var ops = [], n = pts.length, N = P.PDFNumber, O = P.PDFOperator;
      function num(v) { return N.of(Math.round(v * 1000) / 1000); }
      ops.push(O.of('m', [num(pts[0][0]), num(pts[0][1])]));
      // handle direction follows the neighbours, but its length is capped to a third of
      // this segment — a long edge next to a short arc can't overshoot the corner
      function unit(a, b) { var dx = b[0] - a[0], dy = b[1] - a[1], L = Math.sqrt(dx * dx + dy * dy) || 1; return [dx / L, dy / L]; }
      for (var i = 0; i < n; i++) {
        var p0 = pts[(i - 1 + n) % n], p1 = pts[i], p2 = pts[(i + 1) % n], p3 = pts[(i + 2) % n];
        var L = Math.sqrt((p2[0] - p1[0]) * (p2[0] - p1[0]) + (p2[1] - p1[1]) * (p2[1] - p1[1])) / 3;
        var t1 = unit(p0, p2), t2 = unit(p1, p3);
        ops.push(O.of('c', [num(p1[0] + t1[0] * L), num(p1[1] + t1[1] * L),
          num(p2[0] - t2[0] * L), num(p2[1] - t2[1] * L), num(p2[0]), num(p2[1])]));
      }
      ops.push(O.of('h'));
      return ops;
    }
    function roundRectOps(P, x, y, w, hh, r) {
      var O = P.PDFOperator, N = P.PDFNumber, k = 0.5523 * r, ops = [];
      function n(v) { return N.of(Math.round(v * 1000) / 1000); }
      ops.push(O.of('m', [n(x + r), n(y)]));
      ops.push(O.of('l', [n(x + w - r), n(y)]));
      ops.push(O.of('c', [n(x + w - r + k), n(y), n(x + w), n(y + r - k), n(x + w), n(y + r)]));
      ops.push(O.of('l', [n(x + w), n(y + hh - r)]));
      ops.push(O.of('c', [n(x + w), n(y + hh - r + k), n(x + w - r + k), n(y + hh), n(x + w - r), n(y + hh)]));
      ops.push(O.of('l', [n(x + r), n(y + hh)]));
      ops.push(O.of('c', [n(x + r - k), n(y + hh), n(x), n(y + hh - r + k), n(x), n(y + hh - r)]));
      ops.push(O.of('l', [n(x), n(y + r)]));
      ops.push(O.of('c', [n(x), n(y + r - k), n(x + r - k), n(y), n(x + r), n(y)]));
      ops.push(O.of('h'));
      return ops;
    }
    async function buildPDF() {
      var P = window.PDFLib, sh = SHEETS[S.size], pw = (sh.w + 2 * BLEED) * 72, ph = (sh.h + 2 * BLEED) * 72;
      var doc = await P.PDFDocument.create();
      doc.setTitle('StickerMint sticker sheet ' + sh.label);
      var page = doc.addPage([pw, ph]);
      page.drawRectangle({ x: 0, y: 0, width: pw, height: ph, color: P.rgb(1, 1, 1) });
      var O = P.PDFOperator, N = P.PDFNumber, cache = new Map(), ops = [], cut = [];
      function n(v) { return N.of(Math.round(v * 10000) / 10000); }
      var its = items();
      for (var i = 0; i < its.length; i++) {
        var o = its[i], el = o.getElement();
        var wIn = o.width * o.scaleX / ppi, hIn = o.height * o.scaleY / ppi;
        var key = el;
        if (!cache.has(key)) {
          var tw = Math.min(el.width, Math.round(wIn * 300)), th = Math.round(tw * el.height / el.width);
          var c = document.createElement('canvas'); c.width = tw; c.height = th;
          var cx = c.getContext('2d'); cx.imageSmoothingQuality = 'high'; cx.drawImage(el, 0, 0, tw, th);
          var blob = await new Promise(function (r) { c.toBlob(r, 'image/png'); });
          var emb = await doc.embedPng(new Uint8Array(await blob.arrayBuffer()));
          cache.set(key, page.node.newXObject('Im', emb.ref));
        }
        var name = cache.get(key), cen = o.getCenterPoint();
        var CX = (cen.x / ppi + BLEED) * 72, CY = ph - (cen.y / ppi + BLEED) * 72, w = wIn * 72, hh = hIn * 72;
        var phi = -(o.angle || 0) * Math.PI / 180, co = Math.cos(phi), si = Math.sin(phi);
        ops.push(O.of('q'),
          O.of('cm', [n(w * co), n(w * si), n(-hh * si), n(hh * co), n(CX - w / 2 * co + hh / 2 * si), n(CY - w / 2 * si - hh / 2 * co)]),
          O.of('Do', [name]), O.of('Q'));
        var poly = polyPx(o, 1).map(function (p) { return [(p.x / ppi + BLEED) * 72, ph - (p.y / ppi + BLEED) * 72]; });
        cut.push.apply(cut, bezOps(P, poly));
      }
      var ctx = doc.context;
      function sep(name, c1) {
        var fn = ctx.register(ctx.obj({ FunctionType: 2, Domain: [0, 1], C0: [0, 0, 0, 0], C1: c1, N: 1 }));
        return ctx.register(ctx.obj([P.PDFName.of('Separation'), P.PDFName.of(name), P.PDFName.of('DeviceCMYK'), fn]));
      }
      var res = page.node.Resources();
      var cs = ctx.obj({});
      cs.set(P.PDFName.of('CS1'), sep('CutContour', [0, 1, 0, 0]));
      cs.set(P.PDFName.of('CS2'), sep('SheetCut', [1, 0, 0, 0]));
      res.set(P.PDFName.of('ColorSpace'), cs);
      ops.push(O.of('q'), O.of('CS', [P.PDFName.of('CS1')]), O.of('SCN', [N.of(1)]), O.of('w', [N.of(0.5)]));
      ops.push.apply(ops, cut);
      ops.push(O.of('S'), O.of('Q'));
      ops.push(O.of('q'), O.of('CS', [P.PDFName.of('CS2')]), O.of('SCN', [N.of(1)]), O.of('w', [N.of(0.5)]));
      ops.push.apply(ops, roundRectOps(P, BLEED * 72, BLEED * 72, sh.w * 72, sh.h * 72, 0.125 * 72));
      ops.push(O.of('S'), O.of('Q'));
      page.pushOperators.apply(page, ops);
      return await doc.save();
    }
    async function upload(bytes, type) {
      var r = await fetch(WORKER + '/upload', { method: 'POST', headers: { 'Content-Type': type, 'X-API-Key': PUBLIC_KEY }, body: new Blob([bytes], { type: type }) });
      if (!r.ok) throw new Error('Upload failed (' + r.status + ')');
      return (await r.json()).url;
    }
    async function addToCart(btn) {
      btn = btn || panel.querySelector('.smsh-atc');
      if (!items().length) return toast('Add at least one design to the sheet', 'warn');
      if (!validate()) { canvas.requestRenderAll(); return toast('Fix the stickers outlined in red first', 'warn'); }
      var variants = (window.SMN_CONFIG && window.SMN_CONFIG.variants) || [];
      if (!variants.length) return toast('Product not configured', 'warn');
      var variant = variants.find(function (v) { return /sheet/i.test(v.title || ''); }) || variants[0];
      var orig = btn.innerHTML; btn.disabled = true;
      try {
        canvas.discardActiveObject(); hideGuides = true; canvas.renderAll();
        var prev = canvas.toDataURL({ format: 'png', multiplier: Math.min(3, 900 / canvas.getWidth()) });
        hideGuides = false; canvas.renderAll();
        btn.textContent = 'Building print file…';
        var pdf = await buildPDF();
        btn.textContent = 'Uploading…';
        var prevBytes = Uint8Array.from(atob(prev.split(',')[1]), function (c) { return c.charCodeAt(0); });
        var urls = await Promise.all([upload(pdf, 'application/pdf'), upload(prevBytes, 'image/png')]);
        var sh = SHEETS[S.size], n = items().length, total = sheetTotal(S.size, S.finish, S.sheets);
        var props = {
          'Product': 'Sticker Sheet',
          'Sheet Size': sh.label,
          'Sheets': String(S.sheets),
          'Stickers per sheet': String(n),
          'Finish': S.finish,
          '_sheet': 'true', '_studioItem': 'true',
          '_sheetSize': S.size, '_sheetCount': String(S.sheets),
          '_printFileUrl': urls[0], '_previewUrl': urls[1], '_image': urls[1],
          '_totalPrice': total.toFixed(2), '_unitPrice': (total / S.sheets).toFixed(2),
          '_stickerQty': String(S.sheets * n),
          '_TotalWidth': sh.w + '"', '_TotalHeight': sh.h + '"'
        };
        btn.textContent = 'Adding to cart…';
        var r = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: variant.id, quantity: total, properties: props }] }) });
        if (!r.ok) { var er = await r.json().catch(function () { return {}; }); throw new Error(er.description || 'Cart error'); }
        btn.textContent = 'Added ✓';
        S.open = false; // no leave-page warning
        location.href = '/cart';
      } catch (e) {
        hideGuides = false; canvas.renderAll();
        toast(e.message || 'Something went wrong', 'warn');
        btn.innerHTML = orig; btn.disabled = false;
      }
    }

    window.SMSheets = { open: openSheets, close: closeSheets, addFiles: addFiles, buildPDF: buildPDF, state: S, items: items, validate: validate, arrange: arrange,
      newSticker: function () { enterEdit(null); }, edit: enterEdit, saveEdit: saveEdit, back: backToSheet };
    updatePrice();
    if (/[?&]sheet=1\b/.test(location.search)) openSheets();
  }

  function boot() { if (window.SMN) start(); else document.addEventListener('smn:ready', start, { once: true }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
